import { PaxType } from '@booking/entities/pax-type';
import { TravelerTypes } from '@pax/entities/traveler-info';

export const childrenAges = 'childrenAges';

export const paxByGuestRoom = {
  [PaxType.ADULTS]: TravelerTypes.ADULTS,
  [PaxType.CHILDREN]: TravelerTypes.CHILDREN
};

export const paxByGuestRoomPackages = {
  ...paxByGuestRoom,
  [PaxType.INFANTS]: TravelerTypes.INFANTS
};

export const ROOM_GUESTS_MAX = 5;

export interface Room {
  id: number;
  [TravelerTypes.ADULTS]: number;
  [TravelerTypes.CHILDREN]: number;
  childrenAges: number[];
}

export interface Guests {
  quantity: number;
  id: TravelerTypes;
}

export interface GuestRoom {
  [TravelerTypes.ADULTS]?: number;
  [TravelerTypes.CHILDREN]?: number;
  childrenAges?: number[];
}
